<p-dialog
    [(visible)] = "showMap"
    [draggable]="false" (onHide)="closeDialogue()"
    [resizable]="false" [blockScroll]=true [modal]=true >
    <p-header class="row modal-header" style="width: 80vw">
        <h5>
            <b>{{ mapWindowTitle }}</b>
        </h5>
    </p-header>
    <br/>
    <div class="modal-body col-sm-12"> 
        <div>
            <app-plain-mapview [mapData]="mapData"></app-plain-mapview>
        </div>
    </div>
</p-dialog>